import React from 'react';
import { useNavigate } from 'react-router-dom';
import UnifiedState from './UnifiedState';
import './RouteFallback.css';

const RouteFallback = ({
  title = 'Page not found',
  message = 'This destination may have moved or may not be available for your account.',
  homePath = '/overview',
  actionLabel = 'Return to overview',
}) => {
  const navigate = useNavigate();
  return (
    <main className="route-fallback-page">
      <div className="route-fallback-card">
        <p className="route-fallback-code">404</p>
        <UnifiedState
          type="empty"
          title={title}
          message={message}
          actionLabel={actionLabel}
          onAction={() => navigate(homePath, { replace: true })}
        />
      </div>
    </main>
  );
};

export default RouteFallback;
